// The respondent-side Accept Terms of Use API contract, shared between the API
// (builds/consumes these types) and the web app (renders the accept screen).
/** Fallback consent-control label when a survey has no `consent_message` configured. */
export const DEFAULT_CONSENT_MESSAGE = 'I have read and agree to the Terms of Use.';
//# sourceMappingURL=terms.js.map